import createIcon from '../../createIcon';

/**
 * @component @name Toc
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA5SDE3VjdIM1Y5Wk0zIDEzSDE3VjExSDNWMTNaTTMgMTdIMTdWMTVIM1YxN1pNMTkgMTdIMjFWMTVIMTlWMTdaTTE5IDdWOUgyMVY3SDE5Wk0xOSAxM0gyMVYxMUgxOVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Toc = createIcon('Toc', [
  [
    'path',
    {
      d: 'M3 9H17V7H3V9ZM3 13H17V11H3V13ZM3 17H17V15H3V17ZM19 17H21V15H19V17ZM19 7V9H21V7H19ZM19 13H21V11H19V13Z',
      key: 'ccvcb3',
    },
  ],
]);

export default Toc;
